import * as yup from "yup";

const MantenimientoStpValidacionEsquema = yup.object().shape({
    fechaInicio: yup.string().required(),
    fechaFin: yup.string().required()
});

export default MantenimientoStpValidacionEsquema;